import enUS from './en-US';
import esES from './es-ES';
import ptBR from './pt-BR';

export default {
  'pt-BR': ptBR,
  'es-ES': esES,
  'en-US': enUS,
};
